import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const BlogService = {
  getList: async ({ status, page = 1, pageSize = 6 }) => {
    const params = new URLSearchParams({
      ...(status && { status }),

      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/blogs?${params.toString()}`);
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/blogs/${id}`);
    return response.data;
  },
  getfeaturedblogs: async () => {
    const response = await apiService.get("/blogs/featured", {
      params: {
        page: 1,
        size: 1,
      },
    });
    return response.data;
  },
};

export default BlogService;
